<div class="tab-content" [class.loading]="loading">
  <i *ngIf="loading" class="fa-solid fa-spinner fa-spin tab-loading-spinner"></i>
  <ng-container *ngIf="!loading">
    <p class="double-margin-bottom">
      Set a default custom suffix for Recovery S3 buckets managed by Arpio.
      <a href="{{ uiService.s3BucketSuffix }}">Learn More.</a>
    </p>
    <form [formGroup]="resourceConfigsFormModel" (ngSubmit)="updateResourceConfigs()">
      <div>
        <label class="margin-top">S3 Recovery Bucket Suffix</label>
      </div>
      <input
        formControlName="s3RecoveryBucketSuffix"
        class="arpio-input spacer"
        placeholder="dr"
        minlength="2"
        maxlength="12"
      />
      <div *ngIf="canManageResourceDefaults">
        <button
          busy-button
          [busy]="submitting"
          [done]="doneSubmitting"
          type="submit"
          id="update-resource-defaults-button"
          class="arpio-button margin-top"
          [disabled]="updateButtonDisabled"
          (click)="updateResourceConfigs()"
        >
          UPDATE
        </button>
      </div>
    </form>
  </ng-container>
</div>
